import * as React from "react";
import { ThemeContext } from "../../components/theme/ThemeContext";

export const GlobalProvider: React.SFC = props => {
  return <ThemeContext.Provider value="light">{props.children}</ThemeContext.Provider>;
};



// WEBPACK FOOTER //
// ./src/services/provider/Global.provider.tsx